import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { SetLoginFlow } from '~/pages/unAuthorizedPages/LoginScreen/LoginScreen.types';
import { isObject } from './isObject';
import { isNetworkError, isTimeoutError } from './requestErrorKind';
export const errorTextsPath = 'errors';
/** Errors arriving in the body of server error responses. */ export var ServerError = /*#__PURE__*/ function(ServerError) {
    ServerError["MismatchingRelationshipVersion"] = "mismatchingRelationshipVersion";
    ServerError["CannotUpdateWithUnsentChanges"] = "CANNOT_UPDATE_WITH_UNSENT_CHANGES";
    ServerError["NoAmendmentDraftToApply"] = "NO_AMENDMENT_DRAFT_TO_APPLY";
    ServerError["PhoneValidationFailed"] = "phoneValidationFailed";
    ServerError["DuplicateContact"] = "duplicateContact";
    ServerError["DuplicateContactIdentity"] = "DUPLICATE_CONTACT";
    ServerError["UserAlreadyInBusiness"] = "USER_ALREADY_IN_BUSINESS";
    ServerError["UnknownError"] = "unknownError";
    ServerError["BuyerUserAssociatedWithVendor"] = "BuyerUserAssociatedWithVendor";
    ServerError["TargetUserNotBuyer"] = "TARGET_USER_NOT_BUYER";
    ServerError["DeactivatedBuyerRoleNotEditable"] = "DEACTIVATED_BUYER_ROLE_NOT_EDITABLE";
    ServerError["BankTransferAccountBlocked"] = "bankTransferAccountBlocked";
    ServerError["DuplicateNameExists"] = "DUPLICATE_NAME_EXISTS";
    ServerError["InvalidRelationshipStatus"] = "INVALID_RELATIONSHIP_STATUS";
    ServerError["ServiceTemplateAlreadyExists"] = "SERVICE_TEMPLATE_ALREADY_EXISTS";
    ServerError["NameAlreadyExists"] = "NAME_ALREADY_EXISTS";
    ServerError["ProposalTemplateNotRelatedToVendor"] = "PROPOSAL_TEMPLATE_NOT_RELATED_TO_VENDOR";
    ServerError["UserAlreadyAffiliatedWithBusiness"] = "USER_ALREADY_AFFILIATED_WITH_BUSINESS";
    ServerError["PendingInvitationAlreadyExists"] = "PENDING_INVITATION_ALREADY_EXISTS";
    ServerError["RecipientNotFound"] = "RECIPIENT_NOT_FOUND";
    ServerError["InvalidTeamInvitation"] = "INVALID_TEAM_INVITATION";
    ServerError["FailedToArchiveContactDueToExistingRelationships"] = "FAILED_TO_ARCHIVE_CONTACT_DUE_TO_EXISTING_RELATIONSHIPS";
    ServerError["FailedToDeleteContactDueToExistingRelationships"] = "FAILED_TO_DELETE_CONTACT_DUE_TO_EXISTING_RELATIONSHIPS";
    ServerError["FailedToArchiveCustomerDueToAgreement"] = "FAILED_TO_ARCHIVE_CUSTOMER_DUE_TO_AGREEMENT";
    ServerError["FailedToDeleteCustomerDueToAgreement"] = "FAILED_TO_DELETE_CUSTOMER_DUE_TO_AGREEMENT";
    ServerError["CannotArchiveDeletedCustomer"] = "CANNOT_ARCHIVE_DELETED_CUSTOMER";
    ServerError["CannotUnarchiveDeletedCustomer"] = "CANNOT_UNARCHIVE_DELETED_CUSTOMER";
    ServerError["ContactVersionMismatch"] = "CLIENT_CONTACT_VERSION_MISMATCH";
    ServerError["ContactNotEditable"] = "CLIENT_CONTACT_NOT_EDITABLE";
    ServerError["ContactIdentityNotEditable"] = "CONTACT_NOT_EDITABLE";
    ServerError["ContactHasAssociations"] = "CONTACT_HAS_ASSOCIATIONS";
    ServerError["ClientContactAlreadyExists"] = "CLIENT_CONTACT_ALREADY_EXISTS";
    ServerError["CustomerArchived"] = "CUSTOMER_ARCHIVED";
    ServerError["DuplicateNativeClientContact"] = "DUPLICATE_NATIVE_CLIENT_CONTACT";
    ServerError["IncorrectStatusForPaidExternally"] = "incorrectStatusForPaidExternally";
    ServerError["RelationshipAlreadyApproved"] = "RELATIONSHIP_ALREADY_APPROVED";
    ServerError["UserWithEmailAlreadyExists"] = "USER_WITH_EMAIL_ALREADY_EXISTS";
    ServerError["RelationshipAlreadyTerminated"] = "RELATIONSHIP_ALREADY_TERMINATED";
    ServerError["ReviewerEmailIsSimilarToSellerEmail"] = "REVIEWER_EMAIL_IS_SIMILAR_TO_SELLER_EMAIL";
    ServerError["ReviewerEmailIsSimilarToBuyerEmail"] = "REVIEWER_EMAIL_IS_SIMILAR_TO_BUYER_EMAIL";
    ServerError["AdditionalRecipientUserAssociatedWithVendor"] = "ADDITIONAL_RECIPIENT_USER_ASSOCIATED_WITH_VENDOR";
    ServerError["DuplicateReviewerEmail"] = "DUPLICATE_REVIEWER_EMAIL";
    ServerError["CantCreateAgreementExternallyFromDraftWithServiceBundles"] = "CANT_CREATE_AGREEMENT_EXTERNALLY_FROM_DRAFT_WITH_SERVICE_BUNDLES";
    ServerError["UserAlreadySigned"] = "USER_ALREADY_SIGNED";
    ServerError["CounterSignatureMissing"] = "COUNTER_SIGNATURE_MISSING";
    ServerError["InvoiceWasVoided"] = "INVOICE_WAS_VOIDED";
    ServerError["InvoiceAlreadyApproved"] = "INVOICE_ALREADY_APPROVED";
    ServerError["InvoicePaymentNotRetryable"] = "INVOICE_PAYMENT_NOT_RETRYABLE";
    ServerError["NoAmendmentsToApprove"] = "NO_AMENDMENTS_TO_APPROVE";
    ServerError["EmailAlreadyRegistered"] = "EMAIL_ALREADY_REGISTERED";
    ServerError["InvalidOTP"] = "INVALID_OTP";
    ServerError["OtpNotFound"] = "OTP_NOT_FOUND";
    ServerError["InvalidCurrentPassword"] = "INVALID_CURRENT_PASSWORD";
    ServerError["AdHocChargeNotFound"] = "AD_HOC_CHARGE_NOT_FOUND";
    ServerError["InvalidScopeMissingUserInfo"] = "INVALID_SCOPE_MISSING_USER_INFO";
    ServerError["InvalidScopeMissingGmailSend"] = "INVALID_SCOPE_MISSING_GMAIL_SEND";
    ServerError["InvalidKeeperCredentials"] = "INVALID_KEEPER_CREDENTIALS";
    ServerError["BulkBillAlreadyInProgress"] = "BATCH_ALREADY_IN_PROGRESS";
    ServerError["MaxChargesExceeded"] = "MAX_CHARGES_EXCEEDED";
    ServerError["InvalidServiceStatusForBilling"] = "INVALID_SERVICE_STATUS_FOR_BILLING";
    ServerError["RelationshipNotBillable"] = "RELATIONSHIP_NOT_BILLABLE";
    ServerError["InvoiceRefundAmountExceeds"] = "INVOICE_REFUND_AMOUNT_EXCEEDS";
    ServerError["InvoiceRefundAmountLessThanZero"] = "INVOICE_REFUND_AMOUNT_LESS_THAN_ZERO";
    ServerError["InvoiceIsFullyRefunded"] = "INVOICE_IS_FULLY_REFUNDED";
    ServerError["InvoiceCalculateRefundParseQueryFailed"] = "INVOICE_CALCULATE_REFUND_PARSE_QUERY_FAILED";
    ServerError["InvoiceIsNotReadyForRefund"] = "INVOICE_IS_NOT_READY_FOR_REFUND";
    ServerError["InvoiceAlreadyHasOneRefundNotRefunded"] = "INVOICE_ALREADY_HAS_ONE_REFUND_NOT_REFUNDED";
    ServerError["InvoiceRefundInvalidAmount"] = "INVOICE_REFUND_INVALID_AMOUNT";
    ServerError["InvoiceRefundFeesNotSupported"] = "INVOICE_REFUND_FEES_NOT_SUPPORTED";
    ServerError["InvoiceRefundUnknownLineItem"] = "INVOICE_REFUND_UNKNOWN_LINE_ITEM";
    ServerError["InvoiceRefundDuplicateLineItem"] = "INVOICE_REFUND_DUPLICATE_LINE_ITEM";
    ServerError["InvoiceRefundAmountExceedsLineAmount"] = "INVOICE_REFUND_AMOUNT_EXCEEDS_LINE";
    ServerError["InvoiceRefundLinesAllZero"] = "INVOICE_REFUND_LINES_ALL_ZERO";
    ServerError["InvoiceCommandPaymentInvalidFundingSource"] = "INVOICE_COMMAND_PAYMENT_INVALID_FUNDING_SOURCE";
    ServerError["InvalidScheduleTime"] = "INVALID_SCHEDULE_TIME";
    ServerError["DraftAlreadyScheduled"] = "DRAFT_ALREADY_SCHEDULED";
    ServerError["MissingDraftOwnerDetails"] = "MISSING_DRAFT_OWNER_DETAILS";
    ServerError["EmailIsInvalid"] = "email is invalid";
    ServerError["AccountIsDisabled"] = "account is disabled";
    ServerError["PersonalAccountNotSupported"] = "PERSONAL_ACCOUNT_NOT_SUPPORTED";
    ServerError["DraftIsDeleted"] = "DRAFT_IS_DELETED";
    ServerError["DraftNotArchived"] = "DRAFT_NOT_ARCHIVED";
    ServerError["ExplicitApprovalNotAllowedForExternalSign"] = "EXPLICIT_APPROVAL_NOT_ALLOWED_FOR_EXTERNAL_SIGN";
    ServerError["MultiVendorCustomerNotEditable"] = "MULTI_VENDOR_CUSTOMER_NOT_EDITABLE";
    ServerError["ClientNotOwnedByVendor"] = "CLIENT_NOT_OWNED_BY_VENDOR";
    ServerError["APIKeyNotFound"] = "API_KEY_NOT_FOUND";
    ServerError["APIKeyRenameFailed"] = "API_KEY_RENAME_FAILED";
    ServerError["AccountAlreadyExists"] = "ACCOUNT_ALREADY_EXISTS";
    ServerError["InvoiceNotVoided"] = "INVOICE_NOT_VOIDED";
    ServerError["InvoiceNotPaidExternally"] = "INVOICE_NOT_PAID_EXTERNALLY";
    ServerError["LegalTermsNameAlreadyExists"] = "LEGAL_TERMS_NAME_ALREADY_EXISTS";
    ServerError["AttachmentNotFound"] = "ATTACHMENT_NOT_FOUND";
    ServerError["AttachmentsTotalSizeExceeded"] = "ATTACHMENTS_TOTAL_SIZE_EXCEEDED";
    ServerError["DuplicateFileNameNotAllowed"] = "DUPLICATE_FILE_NAME_NOT_ALLOWED";
    ServerError["TooManyAttachments"] = "TOO_MANY_ATTACHMENTS";
    ServerError["AttachmentDisplayNameTooLong"] = "ATTACHMENT_DISPLAY_NAME_TOO_LONG";
    ServerError["ValidationError"] = "VALIDATION_ERROR";
    ServerError["UnresolvedTemplateVariables"] = "UNRESOLVED_TEMPLATE_VARIABLES";
    ServerError["AccountTemporarilyLocked"] = "ACCOUNT_TEMPORARILY_LOCKED";
    ServerError["CustomPageTemplateDuplicateName"] = "CUSTOM_PAGE_TEMPLATE_DUPLICATE_NAME";
    ServerError["FundingSourceNotFound"] = "funding_source_not_found";
    ServerError["FundingSourceTiedToOpenAdHocInvoice"] = "FUNDING_SOURCE_TIED_TO_OPEN_AD_HOC_INVOICE";
    ServerError["FundingSourceAlreadyAuthorized"] = "FUNDING_SOURCE_ALREADY_AUTHORIZED";
    ServerError["FundingSourceStateChanged"] = "FUNDING_SOURCE_STATE_CHANGED";
    ServerError["FundingSourceNotReauthorizable"] = "FUNDING_SOURCE_NOT_REAUTHORIZABLE";
    ServerError["MandateAcceptanceEvidenceMissing"] = "MANDATE_ACCEPTANCE_EVIDENCE_MISSING";
    ServerError["FundingSourceDebitBlocked"] = "FUNDING_SOURCE_DEBIT_BLOCKED";
    ServerError["QboSubscriptionInactive"] = "QBO_SUBSCRIPTION_INACTIVE";
    ServerError["ServiceEffectiveDateTooFarInPast"] = "SERVICE_EFFECTIVE_DATE_TOO_FAR_IN_PAST";
    ServerError["ServiceEffectiveDateMustBeInFuture"] = "SERVICE_EFFECTIVE_DATE_MUST_BE_IN_FUTURE";
    ServerError["StageScheduleOnDateBeforeEffectiveDate"] = "STAGE_SCHEDULE_ON_DATE_BEFORE_EFFECTIVE_DATE";
    ServerError["BulkImportUnreadableFile"] = "BULK_IMPORT_UNREADABLE_FILE";
    ServerError["BulkImportMissingColumns"] = "BULK_IMPORT_MISSING_COLUMNS";
    ServerError["BulkImportTooLarge"] = "BULK_IMPORT_TOO_LARGE";
    ServerError["BulkImportEmptyFile"] = "BULK_IMPORT_EMPTY_FILE";
    ServerError["TextStorageNotFound"] = "TEXT_STORAGE_NOT_FOUND";
    return ServerError;
}({});
const knownPlaidErrors = [
    "bankTransferAccountBlocked"
];
const stripeErrorKeys = [
    'code',
    'doc_url',
    'status',
    'message',
    'param',
    'request_id',
    'type'
];
export const getContactModifiedErrorText = (texts)=>texts.contactModified();
export var CreateRelationshipError = /*#__PURE__*/ function(CreateRelationshipError) {
    CreateRelationshipError["MissingContact"] = "missingContact";
    CreateRelationshipError["MissingServices"] = "missingServices";
    CreateRelationshipError["OptionalServices"] = "optionalServices";
    CreateRelationshipError["MultipleRecipients"] = "multipleRecipients";
    CreateRelationshipError["MissingDetails"] = "missingDetails";
    CreateRelationshipError["Member"] = "member";
    CreateRelationshipError["Phone"] = "phone";
    CreateRelationshipError["Name"] = "name";
    CreateRelationshipError["ReviewerSimilarToSeller"] = "reviewerSimilarToSeller";
    CreateRelationshipError["DuplicateReviewerEmail"] = "duplicateReviewerEmail";
    CreateRelationshipError["DuplicateNativeContact"] = "duplicateNativeContact";
    CreateRelationshipError["PackagesForExternallySign"] = "packagesForExternallySign";
    CreateRelationshipError["PackageNameTooLong"] = "packageNameTooLong";
    CreateRelationshipError["ServiceNameTooLong"] = "serviceNameTooLong";
    CreateRelationshipError["Unknown"] = "unknown";
    CreateRelationshipError["DraftIsDeleted"] = "draftIsDeleted";
    CreateRelationshipError["ExplicitApprovalNotAllowedForExternalSign"] = "explicitApprovalNotAllowedForExternalSign";
    CreateRelationshipError["ServiceEffectiveDateTooFarInPast"] = "serviceEffectiveDateTooFarInPast";
    CreateRelationshipError["UnresolvedTemplateVariables"] = "unresolvedTemplateVariables";
    CreateRelationshipError["ServiceDateBeforeEffectiveDate"] = "serviceDateBeforeEffectiveDate";
    CreateRelationshipError["CounterSignatureMissing"] = "counterSignatureMissing";
    return CreateRelationshipError;
}({});
const payoutAuthorizationErrorByCode = {
    role_claim_missing: 'roleClaimMissing',
    insufficient_role: 'insufficientRole'
};
export class ErrorResponse {
    hasPhoneValidationError() {
        var _this_body_validationErrors_at;
        return isObject(this.body) && 'validationErrors' in this.body && Array.isArray(this.body.validationErrors) && ((_this_body_validationErrors_at = this.body.validationErrors.at(0)) === null || _this_body_validationErrors_at === void 0 ? void 0 : _this_body_validationErrors_at.includes('e164'));
    }
    hasServerError(type) {
        const typeAsArray = Array.isArray(type) ? type : [
            type
        ];
        const code = this.serverErrorCode();
        return code != null && typeAsArray.some((t)=>t === code);
    }
    serverErrorCode() {
        const body = this.body;
        if (typeof body === 'string') {
            return body || null;
        } else if (isObject(body)) {
            const knownErrorKeys = [
                'error',
                'errorCode'
            ];
            const key = knownErrorKeys.find((k)=>k in body && typeof body[k] === 'string');
            return key ? body[key] : null;
        } else {
            return null;
        }
    }
    isTransportFailure() {
        return isTimeoutError(this.maybeAxiosError) || isNetworkError(this.maybeAxiosError);
    }
    hasStatus(status) {
        return this.status != null && status.includes(this.status);
    }
    serverErrorMessage() {
        const body = this.body;
        return isObject(body) && 'message' in body && typeof body.message === 'string' && body.message ? body.message : null;
    }
    hasInvalidServiceStatusError() {
        return this.hasErrorMessageIncluding('invalid service status');
    }
    // WHY: invoice status guards return an uncoded fmt.Sprintf message; delete once the backend returns a real AppErrorCode
    hasStaleInvoiceStatusError() {
        return this.hasErrorMessageIncluding('invalid invoice status');
    }
    isStaleBillingDataError() {
        return this.hasInvalidServiceStatusError() || this.hasServerError([
            "MAX_CHARGES_EXCEEDED",
            "RELATIONSHIP_NOT_BILLABLE"
        ]);
    }
    hasErrorMessageIncluding(substring) {
        return isObject(this.body) && 'error' in this.body && typeof this.body.error === 'string' && this.body.error.includes(substring);
    }
    parseStripeError() {
        if (isObject(this.body) && 'error' in this.body && typeof this.body.error === 'string') {
            try {
                const parsed = JSON.parse(this.body.error);
                return stripeErrorKeys.every((key)=>key in parsed) ? parsed : null;
            } catch (unused) {
                return null;
            }
        } else {
            return null;
        }
    }
    isStripeError() {
        return this.parseStripeError() != null;
    }
    isPlaidError() {
        return this.hasServerError(knownPlaidErrors);
    }
    payoutAuthorizationError() {
        var _payoutAuthorizationErrorByCode_code;
        if (this.status !== 403) return null;
        const code = isObject(this.body) && typeof this.body.code === 'string' ? this.body.code : null;
        return code != null ? (_payoutAuthorizationErrorByCode_code = payoutAuthorizationErrorByCode[code]) !== null && _payoutAuthorizationErrorByCode_code !== void 0 ? _payoutAuthorizationErrorByCode_code : null : null;
    }
    isTooManyAttemptsError() {
        return this.status === 429;
    }
    isBadGateway() {
        return this.status === 502;
    }
    validationErrorCode() {
        return isObject(this.body) && Array.isArray(this.body.errors) && isObject(this.body.errors[0]) ? this.body.errors[0].code || null : null;
    }
    createRelationshipDisableSentry() {
        return this.getRelationshipErrorId() !== "unknown";
    }
    createRelationshipErrorText(texts) {
        const id = this.getRelationshipErrorId();
        const textByErrorId = {
            ["missingContact"]: ()=>texts.relationship.missingContact(),
            ["missingServices"]: ()=>texts.relationship.noServicesIncluded(),
            ["optionalServices"]: ()=>texts.relationship.optionalServicesNotAvailable(),
            ["multipleRecipients"]: ()=>texts.relationship.multipleRecipientsNotAllowed(),
            ["missingDetails"]: ()=>texts.relationship.missingDetails(),
            ["member"]: ()=>texts.relationship.sameBusinessContact(),
            ["phone"]: ()=>texts.relationship.invalidPhoneNumber(),
            ["name"]: ()=>texts.relationship.templateNameExists(),
            ["reviewerSimilarToSeller"]: ()=>texts.relationship.sameBusinessRecipient(),
            ["packagesForExternallySign"]: ()=>texts.relationship.packagesNotAvailable(),
            ["packageNameTooLong"]: ()=>texts.relationship.packageNameTooLong(),
            ["serviceNameTooLong"]: ()=>texts.relationship.serviceNameTooLong(),
            ["duplicateReviewerEmail"]: ()=>texts.relationship.duplicateRecipientEmail(),
            ["duplicateNativeContact"]: ()=>texts.relationship.duplicateNativeContact(),
            ["draftIsDeleted"]: ()=>texts.relationship.draftDeleted(),
            ["explicitApprovalNotAllowedForExternalSign"]: ()=>texts.relationship.explicitApprovalNotAllowed(),
            ["serviceEffectiveDateTooFarInPast"]: ()=>texts.relationship.serviceStartDateTooOld(),
            ["unresolvedTemplateVariables"]: ()=>texts.relationship.unrecognizedCustomFields(),
            ["serviceDateBeforeEffectiveDate"]: ()=>texts.relationship.serviceDateBeforeEffectiveDate(),
            ["counterSignatureMissing"]: ()=>texts.relationship.counterSignatureMissing(),
            ["unknown"]: ()=>texts.relationship.internalError()
        };
        return {
            id,
            text: textByErrorId[id]()
        };
    }
    getRelationshipErrorId() {
        const validationErrorCode = this.validationErrorCode();
        if (validationErrorCode) {
            switch(validationErrorCode){
                case 'title-bundles.name':
                    return "packageNameTooLong";
                case 'title-services.name':
                    return "serviceNameTooLong";
                case 'required-clientcontactid':
                    return "missingContact";
                case 'services_or_service_bundles-services':
                case 'required-services':
                    return "missingServices";
                case 'not_optional-services':
                    return "optionalServices";
                case 'empty-reviewers':
                    return "multipleRecipients";
                default:
                    return "missingDetails";
            }
        } else if (this.hasServerError("BuyerUserAssociatedWithVendor")) {
            return "member";
        } else if (this.hasPhoneValidationError()) {
            return "phone";
        } else if (this.hasServerError("NAME_ALREADY_EXISTS")) {
            return "name";
        } else if (this.hasServerError("COUNTER_SIGNATURE_MISSING")) {
            return "counterSignatureMissing";
        } else if (this.hasServerError([
            "REVIEWER_EMAIL_IS_SIMILAR_TO_SELLER_EMAIL",
            "ADDITIONAL_RECIPIENT_USER_ASSOCIATED_WITH_VENDOR"
        ])) {
            return "reviewerSimilarToSeller";
        } else if (this.hasServerError("CANT_CREATE_AGREEMENT_EXTERNALLY_FROM_DRAFT_WITH_SERVICE_BUNDLES")) {
            return "packagesForExternallySign";
        } else if (this.hasServerError("DUPLICATE_REVIEWER_EMAIL")) {
            return "duplicateReviewerEmail";
        } else if (this.hasServerError("DUPLICATE_NATIVE_CLIENT_CONTACT")) {
            return "duplicateNativeContact";
        } else if (this.hasServerError("DRAFT_IS_DELETED")) {
            return "draftIsDeleted";
        } else if (this.hasServerError("EXPLICIT_APPROVAL_NOT_ALLOWED_FOR_EXTERNAL_SIGN")) {
            return "explicitApprovalNotAllowedForExternalSign";
        } else if (this.hasServerError("SERVICE_EFFECTIVE_DATE_TOO_FAR_IN_PAST")) {
            return "serviceEffectiveDateTooFarInPast";
        } else if (this.hasServerError("UNRESOLVED_TEMPLATE_VARIABLES")) {
            return "unresolvedTemplateVariables";
        } else if (this.hasServerError("STAGE_SCHEDULE_ON_DATE_BEFORE_EFFECTIVE_DATE")) {
            return "serviceDateBeforeEffectiveDate";
        }
        return "unknown";
    }
    saveContactErrorText(texts) {
        if (this.hasPhoneValidationError()) {
            return texts.contact.invalidPhoneNumber();
        } else if (this.hasServerError("duplicateContact")) {
            return texts.contact.duplicateEmailCompany();
        } else if (this.hasServerError("CLIENT_CONTACT_VERSION_MISMATCH")) {
            return getContactModifiedErrorText(texts);
        } else if (this.hasServerError("CLIENT_CONTACT_NOT_EDITABLE")) {
            return texts.contact.notEditable();
        } else if (this.hasServerError("USER_WITH_EMAIL_ALREADY_EXISTS")) {
            return texts.contact.duplicateEmail();
        } else {
            return texts.contact.failedToSave();
        }
    }
    restoreContactErrorText(texts) {
        if (this.hasServerError("CLIENT_CONTACT_VERSION_MISMATCH")) {
            return getContactModifiedErrorText(texts);
        } else {
            return texts.contact.failedToRestore();
        }
    }
    archiveContactErrorText(texts) {
        return this.hasServerError("FAILED_TO_ARCHIVE_CONTACT_DUE_TO_EXISTING_RELATIONSHIPS") ? texts.contact.hasProposalsOrAgreements() : this.hasServerError("CLIENT_CONTACT_VERSION_MISMATCH") ? texts.contactModified() : texts.contact.errorArchiving();
    }
    deleteContactErrorText(texts) {
        return this.hasServerError([
            "FAILED_TO_DELETE_CONTACT_DUE_TO_EXISTING_RELATIONSHIPS",
            "CONTACT_HAS_ASSOCIATIONS"
        ]) ? texts.contact.hasAgreements() : texts.contact.errorDeleting();
    }
    archiveClientErrorText(texts) {
        return this.hasServerError("FAILED_TO_ARCHIVE_CUSTOMER_DUE_TO_AGREEMENT") ? texts.client.hasActiveOrCompletedAgreement() : this.hasServerError("CANNOT_ARCHIVE_DELETED_CUSTOMER") ? texts.client.deletedCannotArchive() : texts.client.errorArchiving();
    }
    deleteClientErrorText(texts) {
        return this.hasServerError("FAILED_TO_DELETE_CUSTOMER_DUE_TO_AGREEMENT") ? texts.client.hasAgreements() : texts.client.errorDeleting();
    }
    restoreClientErrorText(texts) {
        return this.hasServerError("CANNOT_UNARCHIVE_DELETED_CUSTOMER") ? texts.client.deletedCannotRestore() : texts.client.failedToRestore();
    }
    updateUserDetailsErrorText(texts) {
        return this.hasServerError("INVALID_CURRENT_PASSWORD") ? texts.user.invalidCurrentPassword() : texts.user.anErrorOccurred();
    }
    approveRelationshipErrorText(texts) {
        if (this.hasServerError("mismatchingRelationshipVersion")) {
            return texts.mismatchingRelationshipVersion();
        }
        if (this.hasServerError("INVALID_RELATIONSHIP_STATUS")) {
            return texts.proposal.canceled();
        }
        if (this.hasServerError("funding_source_not_found")) {
            return texts.paymentMethod.updated();
        }
        return null;
    }
    invalidTeamInvitationErrorText(texts) {
        return texts.teamInvitation.invalid();
    }
    unvoidInvoiceErrorText(invoice, texts) {
        return this.hasServerError("INVOICE_NOT_VOIDED") ? texts.unvoidInvoiceNoLongerVoided({
            invoiceNumber: invoice.formattedNumber
        }) : texts.failedToUnvoidInvoice({
            invoiceNumber: invoice.formattedNumber
        });
    }
    unmarkPaidExternallyErrorText(invoice, texts) {
        return this.hasServerError("INVOICE_NOT_PAID_EXTERNALLY") ? texts.unmarkPaidExternallyNoLonger({
            invoiceNumber: invoice.formattedNumber
        }) : texts.failedToUnmarkPaidExternally({
            invoiceNumber: invoice.formattedNumber
        });
    }
    removePaymentMethodErrorText(texts) {
        if (this.hasErrorMessageIncluding('used by other approved relationships')) {
            return texts.paymentMethod.usedInOtherApprovedAgreements();
        }
        if (this.hasServerError("FUNDING_SOURCE_TIED_TO_OPEN_AD_HOC_INVOICE")) {
            return texts.paymentMethod.tiedToOpenAdHocInvoice();
        }
        return null;
    }
    getLoginFlowData() {
        var _this_extractContext;
        const loginType = (_this_extractContext = this.extractContext()) === null || _this_extractContext === void 0 ? void 0 : _this_extractContext.loginType;
        const setLoginFlows = Object.values(SetLoginFlow);
        return setLoginFlows.includes(loginType) ? loginType : null;
    }
    getRecipientEmail() {
        var _this_extractContext;
        const recipientEmail = (_this_extractContext = this.extractContext()) === null || _this_extractContext === void 0 ? void 0 : _this_extractContext.recipientEmail;
        return typeof recipientEmail === 'string' ? recipientEmail : null;
    }
    getExistingTemplateId() {
        var _this_extractContext;
        const id = (_this_extractContext = this.extractContext()) === null || _this_extractContext === void 0 ? void 0 : _this_extractContext.existingTemplateId;
        return typeof id === 'string' ? id : undefined;
    }
    isSharedProposalLinkFlow() {
        var _this_extractContext;
        const loginFlow = (_this_extractContext = this.extractContext()) === null || _this_extractContext === void 0 ? void 0 : _this_extractContext.loginFlow;
        return isObject(loginFlow) && loginFlow.sharedProposalLink === true;
    }
    extractContext() {
        if (!this.body || !isObject(this.body) || !('context' in this.body) || !isObject(this.body.context)) {
            return undefined;
        }
        return this.body.context;
    }
    constructor(maybeAxiosError){
        _define_property(this, "maybeAxiosError", void 0);
        _define_property(this, "status", void 0);
        _define_property(this, "body", void 0);
        this.maybeAxiosError = maybeAxiosError;
        if (maybeAxiosError instanceof ErrorResponse) {
            this.status = null;
            Object.assign(this, maybeAxiosError);
        } else {
            this.status = isObject(this.maybeAxiosError) && 'response' in this.maybeAxiosError && isObject(this.maybeAxiosError.response) && typeof this.maybeAxiosError.response.status === 'number' && this.maybeAxiosError.response.status > 0 ? this.maybeAxiosError.response.status : null;
            this.body = isObject(this.maybeAxiosError) && 'response' in this.maybeAxiosError && isObject(this.maybeAxiosError.response) && this.maybeAxiosError.response.data;
        }
    }
}
